import React from 'react';
import { Image } from '@chakra-ui/react';
import logo from '@/assets/slambet/images/logo-brand.png';

export default function Index() {
  return <Image src={logo} maxW="100px" />;
}
